<template>
  <view :style="style">
    <template v-if="componentLoading">
      <Loading />
    </template>
    <template v-else>
      <view class="data-flipper-container">
        <Flipper
          v-for="(item, index) in flipDatas"
          :duration="duration"
          :key="index"
          :frontText="item"
          :backText="item"
          :theme="theme"
          :style="cardStyle"
        />
      </view>
    </template>
  </view>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import { cloneDeep } from "lodash-es"
import Loading from "@p-v/packages/Loading.vue"
import Flipper from "./Flipper.vue"

interface DataFlipperProps {
  theme: string
  duration: number
  cardStyle: { [key: string]: string }
  minLength: number
  style: { [key: string]: string }
}

const props = withDefaults(defineProps<DataFlipperProps>(), {
  theme: () => "",
  duration: () => 1000,
  cardStyle: () => ({
    background: "#000",
  }),
  minLength: () => 1,
  style: () => ({}),
})

const flipHistoryDatas = ref<number[]>([0])
const flipDatas = ref<number[]>([0])

const componentLoading = ref<boolean>(true)

const loading = () => {
  componentLoading.value = true
}

const setData = (val: string | number) => {
  // console.log(val)
  componentLoading.value = false
  flipHistoryDatas.value = cloneDeep(flipDatas.value)
  flipDatas.value = val
    .toString()
    .padStart(props.minLength, "0")
    .split("")
    .map(item => Number(item))
}

defineExpose({ loading, setData })
</script>
